// src/pages/Achats/ListingAchats.jsx
import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import useScrollToTop from "../../hooks/useScrollToTop";
import ScrollIndicator from "./../../hooks/ScrollIndicator";

import { useAchatsListing } from "./useAchatsListing";

import AchatsAdminHeader from "./components/AchatsAdminHeader";
import AchatsFiltersBar from "./components/AchatsFiltersBar";
import AchatsPanel from "./components/AchatsPanel";
import AchatsPagination from "./components/AchatsPagination";
import AchatsRevenueChart from "./components/AchatsRevenueChart";

const PAGE =
  "min-h-screen bg-slate-50 text-slate-900 dark:bg-slate-950 dark:text-slate-50";

export default function ListingAchats() {
  useScrollToTop();

  const {
    filteredAchats,
    pageRows,
    stats,
    revenue12,
    formuleOptions,

    loading,

    q,
    setQ,
    formule,
    setFormule,
    paidOnly,
    setPaidOnly,
    dateFrom,
    setDateFrom,
    dateTo,
    setDateTo,
    sort,
    setSort,

    page,
    setPage,
    pageSize,
    setPageSize,
    pageCount,

    loadAchats,
    exportCSV,
    resetFilters,
  } = useAchatsListing();

  return (
    <div className={PAGE}>
      <ScrollIndicator />

      <main className="mx-auto w-full max-w-[1280px] px-3 pb-12 pt-[120px] sm:px-5 md:pt-[145px]">
        <div className="space-y-6">
          <AchatsAdminHeader
            stats={stats}
            loading={loading}
            onRefresh={loadAchats}
          />

          <AchatsFiltersBar
            q={q}
            setQ={(value) => {
              setQ(value);
              setPage(1);
            }}
            formule={formule}
            setFormule={(value) => {
              setFormule(value);
              setPage(1);
            }}
            formuleOptions={formuleOptions}
            paidOnly={paidOnly}
            setPaidOnly={(value) => {
              setPaidOnly(value);
              setPage(1);
            }}
            dateFrom={dateFrom}
            setDateFrom={(value) => {
              setDateFrom(value);
              setPage(1);
            }}
            dateTo={dateTo}
            setDateTo={(value) => {
              setDateTo(value);
              setPage(1);
            }}
            sort={sort}
            setSort={(value) => {
              setSort(value);
              setPage(1);
            }}
            onExport={exportCSV}
            onResetFilters={resetFilters}
          />

          <AchatsRevenueChart data={revenue12} />

          <AchatsPanel
            rows={pageRows}
            loading={loading}
            searchTerm={q}
          />

          <AchatsPagination
            page={page}
            setPage={setPage}
            pageCount={pageCount}
            pageSize={pageSize}
            setPageSize={setPageSize}
            total={filteredAchats.length}
          />

          <div className="rounded-[24px] border border-slate-200 bg-white p-4 text-sm text-slate-600 shadow-sm dark:border-slate-800 dark:bg-slate-900 dark:text-slate-300">
            Total filtré : <strong>{stats.count}</strong> achat
            {stats.count > 1 ? "s" : ""} • Payés :{" "}
            <strong>{stats.paidCount}</strong> • En attente :{" "}
            <strong>{stats.pendingCount}</strong> • TournoiPro :{" "}
            <strong>{stats.proCount}</strong> • TournoiUltim :{" "}
            <strong>{stats.ultimCount}</strong>
          </div>
        </div>
      </main>

      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
}